import FirestoreDocument from "../../../types/FirestoreDocument";
import { nullable, string, timestamp } from "../../../types/_types";

export const DistributionRef = FirestoreDocument.extend({
	status: string(),
	scheduledAt: nullable(timestamp()),
});
